'use client';
import { XYCHART_AXIS_TITLE_COLOR } from './xychart-constants';
import type { XYChartLayout } from './xychart-types';
export interface XYChartAxisTitlesProps {
    layout: XYChartLayout;
}
export function XYChartAxisTitles({ layout }: XYChartAxisTitlesProps) {
    const xAxisTitleY = layout.plotHeight + 44;
    return (<>
      {!layout.horizontal && layout.xAxisTitle && (<text x={layout.plotWidth / 2} y={xAxisTitleY} textAnchor="middle" fontSize={11.5} fontWeight={600} letterSpacing="0.04em" fill={XYCHART_AXIS_TITLE_COLOR}>
          {layout.xAxisTitle}
        </text>)}
      {!layout.horizontal && layout.yAxisTitle && (<text x={-44} y={layout.plotHeight / 2} transform={`rotate(-90 -44 ${layout.plotHeight / 2})`} textAnchor="middle" fontSize={11.5} fontWeight={600} letterSpacing="0.04em" fill={XYCHART_AXIS_TITLE_COLOR}>
          {layout.yAxisTitle}
        </text>)}
      {layout.horizontal && layout.yAxisTitle && (<text x={layout.plotWidth / 2} y={layout.plotHeight + 38} textAnchor="middle" fontSize={11.5} fontWeight={600} letterSpacing="0.04em" fill={XYCHART_AXIS_TITLE_COLOR}>
          {layout.yAxisTitle}
        </text>)}
      {layout.horizontal && layout.xAxisTitle && (<text x={-72} y={layout.plotHeight / 2} transform={`rotate(-90 -72 ${layout.plotHeight / 2})`} textAnchor="middle" fontSize={11.5} fontWeight={600} letterSpacing="0.04em" fill={XYCHART_AXIS_TITLE_COLOR}>
          {layout.xAxisTitle}
        </text>)}
    </>);
}
